var breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
var maxWidths = {
  sm: 540,
  md: 720,
  lg: 970
}; // TODO pull breakpoints from theme provider
// mosaic's breakpoints object to array

var ssBreakpoints = Array.from(Object.keys(breakpoints), function (k) {
  return breakpoints[k] !== 0 ? "".concat(breakpoints[k], "px") : undefined;
}).filter(Boolean);
ssBreakpoints.sm = ssBreakpoints[0];
ssBreakpoints.md = ssBreakpoints[1];
ssBreakpoints.lg = ssBreakpoints[2];
ssBreakpoints.xl = ssBreakpoints[3];
var COLS_COUNT = 12;
export { ssBreakpoints, breakpoints, maxWidths, COLS_COUNT };